export var TOGGLE_NAVBAR = 'TOGGLE_NAVBAR';
export var SHOW_NAVBAR = 'SHOW_NAVBAR';
export var HIDE_NAVBAR = 'HIDE_NAVBAR';